import request from '@/utils/request';

let BASE_URL = '';
const hostName = window.location.hostname;
if (hostName === 'pschool.songshuai.com') {
  BASE_URL = 'https://pschool-api.songshuai.com/pt/api';
} else if (hostName === 'pschool-pre.songshuai.com') {
  BASE_URL = 'https://pschool-api-pre.songshuai.com/pt/api';
} else if (hostName === 'pschool-test.songshuai.com') {
  BASE_URL = 'https://pschool-api-test.songshuai.com/pt/api';
} else if (hostName === 'pschool.fe.dev.myyixue.com') {
  BASE_URL = 'http://pschool-api.be.dev.myyixue.com/pt/api';
} else {
  BASE_URL = 'http://pschool-api.be.dev.myyixue.com/pt/api';
  // BASE_URL = 'https://test-pschool.myyixue.com/pt/api';
}

export const getCategory = (data) => request({
  url: `${BASE_URL}/crm/getCategory`,
  method: 'post',
  data,
});
// 获取年级
export const getTeacherYear = (data) => request({
  url: `${BASE_URL}/crm/getTeacherYear`,
  method: 'post',
  data,
});
// 获取班级
export const getTeacherClass = (data) => request({
  url: `${BASE_URL}/crm/getTeacherClass`,
  method: 'post',
  data,
});
//  getEvaluateListTob
export const getEvaluateList = (data) => request({
  url: `${BASE_URL}/task/getTaskList`,
  method: 'post',
  data,
});
// 巩固练习记录
export const getTestRecord = (data) => request({
  url: `${BASE_URL}/evaluate/consolidateRecord`,
  method: 'post',
  data,
});
// 获取班级报告学生掌握情况列表
export const getStudentScoreList = (data) => request({
  url: `${BASE_URL}/report/getStudentScoreList`,
  method: 'post',
  data,
});
// 获取班级报告学生掌握情况学生分布
export const getStudentAbilityList = (data) => request({
  url: `${BASE_URL}/report/getStudentAbilityList`,
  method: 'post',
  data,
});
// 获取年级包含下属班级
export const getTeacherClassYear = (data) => request({
  url: `${BASE_URL}/crm/getTeacherClassYear`,
  method: 'post',
  data,
});

// 获取班级报告详情
export const getClassReport = (data) => request({
  url: `${BASE_URL}/report/getClassReport`,
  method: 'post',
  data,
});

// 获取班级对比报告
export const getClassReportContrast = (data) => request({
  url: `${BASE_URL}/report/getClassReportContrast`,
  method: 'post',
  data,
});

// 获取班级报告及班级对比报告的班级列表
export const getClassListByBatchId = (data) => request({
  url: `${BASE_URL}/report/getClassListByBatchId`,
  method: 'post',
  data,
});

// 新建测评
export const createEvaluate = (data) => request({
  url: `${BASE_URL}/task/create`,
  method: 'post',
  data,
});

// 获取班级报告完成情况列表
export const getCompletionStatusList = (data) => request({
  url: `${BASE_URL}/report/getCompletionStatusList`,
  method: 'post',
  data,
});

// 创建知识点或者错题巩固练习
export const createKnowledgeOrWrong = (data) => request({
  url: `${BASE_URL}/evaluate/createKnowledgeOrWrong`,
  method: 'post',
  data,
});

// 获取班级报告知识点掌握程度列表
export const getCodeList = (data) => request({
  url: `${BASE_URL}/report/getCodeList`,
  method: 'post',
  data,
});

// 学生知识点明细
export const knowledgeDetail = (data) => request({
  url: `${BASE_URL}/evaluate/knowledgeDetail`,
  method: 'post',
  data,
});

// 获取班级共性错题
export const commonWrong = (data) => request({
  url: `${BASE_URL}/evaluate/commonWrong`,
  method: 'post',
  data,
});

// 获取知识点或者错题详情
export const getContentDetail = (data) => request({
  url: `${BASE_URL}/evaluate/getContentDetail?${data}`,
  method: 'GET',
  data,
});

// 知识点关联错题
export const knowledgeWrong = (data) => request({
  url: `${BASE_URL}/evaluate/knowledgeWrong`,
  method: 'post',
  data,
});

// 长链接转短连接
export const getShortUrl = (data) => request({
  url: `${BASE_URL}/evaluate/getShortUrl`,
  method: 'post',
  data,
});

// 错题的人数
export const studentsFinishInfo = (data) => request({
  url: `${BASE_URL}/evaluate/studentsFinishInfo`,
  method: 'post',
  data,
});

// 获取知识点列表
export const getKnowledgeList = (data) => request({
  url: `${BASE_URL}/cms/getKnowledgeList`,
  method: 'post',
  data,
});
// 课程树
export const getCourseTree = (data) => request({
  url: `${BASE_URL}/cms/getCourseTree`,
  method: 'post',
  data,
});
// 通过知识点code、题型、难度获取试题
export const getQuestionListByCombinInfo = (data) => request({
  url: `${BASE_URL}/cms/searchQuestion`,
  method: 'post',
  data,
});
// 通过知识点code获取视频、讲义
export const getVideoAndHandoutByCode = (data) => request({
  url: `${BASE_URL}/cms/getVideoAndHandoutByCode`,
  method: 'post',
  data,
});
// 通过知识点code获取试题
export const getQuestionListByKnowledgeCode = (data) => request({
  url: `${BASE_URL}/cms/getQuestionListByKnowledgeCode`,
  method: 'post',
  data,
});
// 通过章和课次获取知识点信息（含视频、讲义）
export const getInfoByChapterAndLesson = (data) => request({
  url: `${BASE_URL}/cms/getInfoByChapterAndLesson`,
  method: 'post',
  data,
});
// evaCenter/deleteEvaluate
export const deleteEvaluate = (data) => request({
  url: `${BASE_URL}/task/deleteTask`,
  method: 'post',
  data,
});

// 获取预习报告
export const getPreviewReport = (data) => request({
  url: `${BASE_URL}/report/getPreviewReport`,
  method: 'post',
  data,
});
// 课程列表（新）
export const getCourseList = (data) => request({
  url: `${BASE_URL}/crm/getCourseList`,
  method: 'post',
  data,
});

// 用户反馈（新）
export const feedBack = (data) => request({
  url: `${BASE_URL}/user/feedBack`,
  method: 'post',
  data,
});

// 获取老师授课科目
export const getSubjectList = (data) => request({
  url: `${BASE_URL}/crm/getSubjectList`,
  method: 'post',
  data,
});

// 获取跳转链接
export const getJumpLink = (data) => request({
  url: `${BASE_URL}/teacherCenter/getJumpLink`,
  method: 'post',
  data,
});

// 获取报告页概览
export const getOverview = (data) => request({
  url: `${BASE_URL}/exerciseReport/getOverview`,
  method: 'post',
  data,
});

// 获取共性错题详情
export const getCommonWrongQuestionDetails = (data) => request({
  url: `${BASE_URL}/report/questionDetails`,
  method: 'post',
  data,
});

// 获取共性错题
export const getCommonWrongQuestion = (data) => request({
  url: `${BASE_URL}/report/commonWrongQuestion`,
  method: 'post',
  data,
});

// 获取共同薄弱知识点
export const getWeakCodeList = (data) => request({
  url: `${BASE_URL}/exerciseReport/getWeakCodeList`,
  method: 'post',
  data,
});

// 获取单个薄弱知识点下学生列表
export const getStuListByCode = (data) => request({
  url: `${BASE_URL}/exerciseReport/getStuListByCode`,
  method: 'post',
  data,
});

// 获取练习内容
export const getQuestionList = (data) => request({
  url: `${BASE_URL}/exerciseReport/getQuestionList`,
  method: 'post',
  data,
});
// 获取练习报告的题目分析
export const getQuestionAnalysisList = (data) => request({
  url: `${BASE_URL}/exerciseReport/getQuestionAnalysisList`,
  method: 'post',
  data,
});
// 获取练习报告的题目详情
export const getQuestionAnalysisDetail = (data) => request({
  url: `${BASE_URL}/exerciseReport/getQuestionAnalysisDetail`,
  method: 'post',
  data,
});
// 获取练习内容题目详情
export const getSGVList = (data) => request({
  url: `${BASE_URL}/cms/getSGVList`,
  method: 'post',
  data,
});
// 获取老师授课科目(练习中心)
export const getCmsSubjectList = (data) => request({
  url: `${BASE_URL}/cms/getSubjectList`,
  method: 'post',
  data,
});
// 获取练习内容题目详情
export const getClassSGVList = (data) => request({
  url: `${BASE_URL}/classOverview/getClassSGVList `,
  method: 'post',
  data,
});
// 获取老师授课科目(练习中心)
export const getClassSubjectList = (data) => request({
  url: `${BASE_URL}/classOverview/getClassSubjectList`,
  method: 'post',
  data,
});
// 获取章节(练习中心)
export const getCmsCourseTree = (data) => request({
  url: `${BASE_URL}/cms/getCourseTreeDetails`,
  method: 'post',
  data,
});
// 获取知识点(练习中心)
export const getQuestionPackageList = (data) => request({
  url: `${BASE_URL}/cms/getQuestionPackageList`,
  method: 'post',
  data,
});
// 理科根据知识点获取试题(练习中心)
export const getQuestionByCodes = (data) => request({
  url: `${BASE_URL}/cms/getQuestionByCodes`,
  method: 'post',
  data,
});
// 文科根据知识点获取试题(练习中心)
export const getQuestionByPackage = (data) => request({
  url: `${BASE_URL}/cms/getQuestionListByPackage`,
  method: 'post',
  data,
});
// 根据试题id获取试题详情(练习中心)
export const getQuestionDetailById = (data) => request({
  url: `${BASE_URL}/cms/getQuestionDetailById`,
  method: 'post',
  data,
});
// 试题篮打印调用
export const getQuestionInfoByIds = (data) => request({
  url: `${BASE_URL}/cms/getQuestionInfoByIds`,
  method: 'post',
  data,
});
// 精准教学驾驶舱 学校学情（智适应）
export const getAiEvaluationDetail = (data) => request({
  url: `${BASE_URL}/v2/schoolreport/getAiEvaluationDetail`,
  method: 'post',
  data,
});

// 精准测评学情
export const getEvaluationDetail = (data) => request({
  url: `${BASE_URL}/schoolreport/getEvaluationDetail`,
  method: 'post',
  data,
});
export const getAccurateCategory = (data) => request({
  url: `${BASE_URL}/classOverview/getAccurateCategory`,
  method: 'post',
  data,
});
export const getClassAccurateCategory = (data) => request({
  url: `${BASE_URL}/classOverview/getClassAccurateCategory`,
  method: 'post',
  data,
});

// 学情分析 知识点学情
export const tagCodeStudySituation = (data) => request({
  url: `${BASE_URL}/v2/class/tagCodeStudySituation`,
  method: 'post',
  data,
});

// 学情分析 知识点学情
export const getKnowledgeDetailsAction = (data) => request({
  url: `${BASE_URL}/v2/class/getKnowledgeDetails`,
  method: 'post',
  data,
});

// 学情分析 知识点学情
export const getStudentKnowledgeDetails = (data) => request({
  url: `${BASE_URL}/v2/student/getKnowledgeDetails`,
  method: 'post',
  data,
});

// 知识点学情 获取班级所属科目
export const getSubjectCourseList = (data) => request({
  url: `${BASE_URL}/v2/class/getSubjectCourseList`,
  method: 'post',
  data,
});
// 班级概况 获取班级学习成果
export const getClassLearningOutcomes = (data) => request({
  url: `${BASE_URL}/v2/classOverview/getClassLearningOutcomes`,
  method: 'post',
  data,
});
// 班级概况 获取班级近况
export const getClassSituation = (data) => request({
  url: `${BASE_URL}/v2/classOverview/getClassSituation`,
  method: 'post',
  data,
});
// 班级概况 获取年级和班级列表
export const getYearClass = (data) => request({
  url: `${BASE_URL}/classOverview/getYearClass`,
  method: 'post',
  data,
});
// 学情分析 获取班级学科下的课程列表
export const getClassCourse = (data) => request({
  url: `${BASE_URL}/classOverview/getClassCourse`,
  method: 'post',
  data,
});
// 班级共性错题
export const getCommonWrong = (data) => request({
  url: `${BASE_URL}/v2/classOverview/commonWrong`,
  method: 'post',
  data,
});
// 班级共性错题详情
export const questionDetails = (data) => request({
  url: `${BASE_URL}/classOverview/questionDetails`,
  method: 'post',
  data,
});
// 学情分析 获取班级学科列表
export const getClassSubject = (data) => request({
  url: `${BASE_URL}/classOverview/getClassSubject`,
  method: 'post',
  data,
});
// 学情分析  获取班级知识点图谱
export const getClassKnowledgeAtlas = (data) => request({
  url: `${BASE_URL}/classOverview/getClassKnowledgeAtlas`,
  method: 'post',
  data,
});
// 获取班级练习分析
export const getClassExerciseAnalysis = (data) => request({
  url: `${BASE_URL}/classOverview/getClassExerciseAnalysis`,
  method: 'post',
  data,
});
// 班级学情 精准测评分析
export const getClassEvaluationDetail = (data) => request({
  url: `${BASE_URL}/classOverview/getEvaluationDetail`,
  method: 'post',
  data,
});
// 获取上一次访问的班级、年级
export const getLastVisitClass = (data) => request({
  url: `${BASE_URL}/classOverview/getLastVisitClass`,
  method: 'post',
  data,
});
// 获取lastInfo(练习中心)
export const getLastInfo = (data) => request({
  url: `${BASE_URL}/evaluate/lastInfo`,
  method: 'post',
  data,
});
// 获取北斗lastInfo(练习中心)
export const getExtraLastInfo = (data) => request({
  url: `${BASE_URL}/common/exercise/extraLastInfo`,
  method: 'post',
  data,
});
// 获取班级报告学生掌握情况列表(练习中心)
export const getStuScoreList = (data) => request({
  url: `${BASE_URL}/exerciseReport/getStuList`,
  method: 'post',
  data,
});
// 获取班级练习高频错题列表(练习中心)
export const getClassCommonWrongQuestionList = (data) => request({
  url: `${BASE_URL}/common/exercise/classCommonWrongQuestionList`,
  method: 'post',
  data,
});
// 获取测评高频错题列表测评中心)
export const evaluateClassCommonWrongQuestionList = (data) => request({
  url: `${BASE_URL}/common/Evaluate/classCommonWrongQuestionList`,
  method: 'post',
  data,
});
// 获取测评高频错题列表(练习中心)详情
export const evaluateQuestionDetails = (data) => request({
  url: `${BASE_URL}/common/Evaluate/questionDetails`,
  method: 'post',
  data,
});
// 获取测评高频错题列表(练习中心)详情
export const getQuestionDetails = (data) => request({
  url: `${BASE_URL}/common/exercise/questionDetails`,
  method: 'post',
  data,
});
// 获取班级薄弱知识点列表(练习中心)
export const getCommonWeakTagCodeList = (data) => request({
  url: `${BASE_URL}/common/exercise/commonWeakTagCodeList`,
  method: 'post',
  data,
});
// 获取班级薄弱知识点列表(测评中心)
export const getCommonWeakTagList = (data) => request({
  url: `${BASE_URL}/common/evaluate/commonWeakTagCodeList`,
  method: 'post',
  data,
});
// 获取班级薄弱知识点详情(练习中心)
export const getCommonWeakTagCodeDetail = (data) => request({
  url: `${BASE_URL}/common/exercise/commonWeakTagCodeDetail`,
  method: 'post',
  data,
});
// 获取班级薄弱知识点详情(测评中心)
export const getCommonWeakTagDetail = (data) => request({
  url: `${BASE_URL}/common/evaluate/commonWeakTagCodeDetail`,
  method: 'post',
  data,
});
//  获取班级学生列表(个人学情)
export const getStudentList = (data) => request({
  url: `${BASE_URL}/classOverview/studentList`,
  method: 'post',
  data,
});
// 获取学生练习分析(个人学情)
export const getStudentExerciseAnalysis = (data) => request({
  url: `${BASE_URL}/classOverview/getStudentExerciseAnalysis`,
  method: 'post',
  data,
});
// 测评分析(个人学情)
export const getEvaluationAnalyse = (data) => request({
  url: `${BASE_URL}/student/getEvaluationAnalyses`,
  method: 'post',
  data,
});
// 智适应学习概览(个人学情)
export const getTagCodeStudySituation = (data) => request({
  url: `${BASE_URL}/v2/student/tagCodeStudySituation`,
  method: 'post',
  data,
});
// 个人学情学习时间分布 答题分布
export const studentLearningSituation = (data) => request({
  url: `${BASE_URL}/v2/student/studentLearningSituation`,
  method: 'post',
  data,
});
// 布置测评选择测评后返回该测评知识点数和预计用时
export const getTestInfo = (data) => request({
  url: `${BASE_URL}/evaluate/getTestInfo`,
  method: 'post',
  data,
});
// 获取班级不良习惯列表
export const getClassHabitList = (data) => request({
  url: `${BASE_URL}/classOverview/getClassHabitList`,
  method: 'post',
  data,
});
// 获取班级学生详情
export const getClassStudentLearnDetail = (data) => request({
  url: `${BASE_URL}/v2/classOverview/getClassStudentLearnDetail`,
  method: 'post',
  data,
});
// 知识点学情
export const tagCodeStudySituationDetail = (data) => request({
  url: `${BASE_URL}/v2/class/tagCodeStudySituationDetail`,
  method: 'post',
  data,
});
// 获取班级下的学生信息
export const studentInfo = (data) => request({
  url: `${BASE_URL}/classOverview/studentInfo`,
  method: 'post',
  data,
});
